const HIGHEST_SCALE_IDX: number = 9

export function getColorString(maxOrdinal: number, currentOrdinal: number): string {
	return `var(${extractColor(maxOrdinal, currentOrdinal)}800)`
}

export function getBackgroundColorString(maxOrdinal: number, currentOrdinal: number): string {
	return `var(${extractColor(maxOrdinal, currentOrdinal)}200)`
}

function extractColor(maxOrdinal: number, currentOrdinal: number) {
	return colorScales[clamp(maxOrdinal, HIGHEST_SCALE_IDX)][clamp(currentOrdinal, maxOrdinal)]
}

function clamp(value: number, max: number) {
	return Math.min(Math.max(value, 0), max)
}

/**
 * A mapping from the highest possible ordinal index to an array of color strings. The highest possible ordinal index
 * (the longest scale) is 9 (10 elements). The minimum is 0 (1 element).
 * The ordinal index of a value in the analysis scale is the index of the respective color in the array.
 */
const colorScales: Record<number, string[]> = {
	0: ['--color-highlight-green-'],
	1: ['--color-highlight-green-', '--color-highlight-red-'],
	2: ['--color-highlight-green-', '--color-highlight-yellow-', '--color-highlight-red-'],
	3: [
		'--color-highlight-green-',
		'--color-highlight-yellow-',
		'--color-peach-',
		'--color-highlight-red-'
	],
	4: [
		'--color-highlight-green-',
		'--color-spring-',
		'--color-highlight-yellow-',
		'--color-peach-',
		'--color-highlight-red-'
	],
	5: [
		'--color-highlight-green-',
		'--color-spring-',
		'--color-highlight-yellow-',
		'--color-peach-',
		'--color-tangerine-',
		'--color-highlight-red-'
	],
	6: [
		'--color-highlight-green-',
		'--color-spring-',
		'--color-highlight-yellow-',
		'--color-gold-',
		'--color-peach-',
		'--color-tangerine-',
		'--color-highlight-red-'
	],
	7: [
		'--color-highlight-green-',
		'--color-lime-',
		'--color-spring-',
		'--color-highlight-yellow-',
		'--color-gold-',
		'--color-peach-',
		'--color-tangerine-',
		'--color-highlight-red-'
	],
	8: [
		'--color-highlight-green-',
		'--color-lime-',
		'--color-spring-',
		'--color-highlight-yellow-',
		'--color-gold-',
		'--color-saffron-',
		'--color-peach-',
		'--color-tangerine-',
		'--color-highlight-red-'
	],
	9: [
		'--color-highlight-green-',
		'--color-lime-',
		'--color-spring-',
		'--color-highlight-yellow-',
		'--color-gold-',
		'--color-saffron-',
		'--color-highlight-orange-',
		'--color-peach-',
		'--color-tangerine-',
		'--color-highlight-red-'
	]
}
